<template>
  <sticky-basic />
</template>

<script>
import { createPage } from '@mpxjs/core'

createPage({})
</script>

<style lang="stylus">
.cube-sticky-demo-item
  margin-bottom 20px
</style>

<script type="application/json">
  {
    "usingComponents": {
      "base-container": "../../components/base-container/index",
      "cube-sticky": "@mpxjs/mpx-cube-ui/src/components/sticky/index",
      "cube-sticky-ele": "@mpxjs/mpx-cube-ui/src/components/sticky/sticky-ele/index",
      "sticky-basic": "./sticky-basic.mpx"
    }
  }
</script>
